var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 3.58214 3.58214 0 8 0C12.4179 0 16 3.58214 16 8C16 12.4179 12.4179 16 8 16C3.58214 16 0 12.4179 0 8ZM1.35714 8C1.35714 11.6679 4.33214 14.6429 8 14.6429C11.6679 14.6429 14.6429 11.6679 14.6429 8C14.6429 4.33214 11.6679 1.35714 8 1.35714C4.33214 1.35714 1.35714 4.33214 1.35714 8ZM7.39363 5.46323C7.23288 5.30249 7.14258 5.08447 7.14258 4.85714C7.14258 4.62981 7.23288 4.4118 7.39363 4.25105C7.55437 4.09031 7.77239 4 7.99972 4C8.22705 4 8.44507 4.09031 8.60581 4.25105C8.76656 4.4118 8.85686 4.62981 8.85686 4.85714C8.85686 5.08447 8.76656 5.30249 8.60581 5.46323C8.44507 5.62398 8.22705 5.71429 7.99972 5.71429C7.77239 5.71429 7.55437 5.62398 7.39363 5.46323ZM7.57115 6.85714H8.42829C8.50686 6.85714 8.57115 6.92143 8.57115 7V11.8571C8.57115 11.9357 8.50686 12 8.42829 12H7.57115C7.49258 12 7.42829 11.9357 7.42829 11.8571V7C7.42829 6.92143 7.49258 6.85714 7.57115 6.85714Z",
    fill: "#009AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.bd833499.svg";
export { ForwardRef as ReactComponent };